// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"5c6c9534","334":"5974e480","701":"5974e480","932":"731501eb"}[chunkId] + ".chunk.css";
};